<script setup lang="ts">
import { formatAmount, formatDateFrench } from '@/utils/formatters';
import axios from 'axios';
import { inject, onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const loading = ref(false);
const errorMessage = ref('');

const itemsList = ref([] as any[]);
const queryParams = reactive({
    pageNumber: 1,
});
const pagination = reactive({
    total: 0,
    per_page: 16,
    last_page: 1
});
onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
    doGetCommandes();
});

async function doGetCommandes() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/market/commands?${queryString}`);
        itemsList.value = httpResponse.data.data;
        pagination.total = httpResponse.data.total;
        pagination.per_page = httpResponse.data.per_page;
        pagination.last_page = httpResponse.data.last_page;
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

function onPaginate(pageNumber: number) {
    queryParams.pageNumber = pageNumber;
    doGetCommandes();
}
</script>
<template>
    <main>
        <!--Page-->
        <section class="container-full-5">
            
            <h2 class="secondary-font gap-4 mt-2 mb-6">
            Mes Commandes
            </h2>

            <div style="height: 300px; display: flex; justify-content: center; align-items: center;" v-if="loading">
                <div class="loader dark"></div>
            </div>
            <div v-if="!loading && itemsList.length > 0">
                <!--Commande-->
                
                <router-link :to="'/front/market/commandes/' + item.id" v-for="(item, index) of itemsList" :key="index">
                    <div class="card flex-mobile align-items-center px-6 py-1 border-grey mb-5">
                        <div class="s7_mobile my-6">
                            <h3 class="secondary-font text-grey-800 mb-3">#{{ item.num_commande }}</h3>
                            <h5 class="text-grey-600 secondary-font mb-3">{{ formatAmount(item.total || item.sous_total) }} F CFA</h5>
                            <p class="font-semibold secondary-font text-medium text-grey-600 mb-4">{{ formatDateFrench(item.created_at) }}</p>
                            <span class="tag-state notif stroke">{{ item.statut }}</span>
                        </div>
                        <div class="s13_mobile text-right" style="display: flex;align-items: center;justify-content: end;gap: 25px;">
                            <img :src="BACKEND_URL + '/assets/market_produits/300/' + product.image" style="max-height: 110px; max-width: 110px;" :title="product.nom" v-for="(product, subindex) of item.produits.slice(0, 3)" :key="subindex" />
                        </div>
                    </div>
                </router-link>
                <!--End Commande-->
            </div>
            <div style="height: 300px; display: flex; justify-content: center; align-items: center;" v-if="!loading && itemsList.length == 0">
                <div class="text-center mt-40 mb-40">
                    <h3 class="secondary-font font-semibold">Aucune commande enregistré</h3>
                </div>
            </div>

            <div class="clear-both h-70"></div>
            
            <!--Pagination-->
            <div style="display: flex; flex-direction: row; justify-content: center;">
                <custom-pagination v-model="queryParams.pageNumber" :total="pagination.total" :per-page="pagination.per_page" :last_page="pagination.last_page" @update:modelValue="onPaginate" />
            </div>
            <!---->
        </section>
    </main>
</template>